import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatDate(dateString) {
  if (!dateString) return '-';
  const date = new Date(dateString);
  return date.toLocaleDateString('fr-FR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  });
}

export function formatDateTime(dateString) {
  if (!dateString) return '-';
  const date = new Date(dateString);
  return date.toLocaleDateString('fr-FR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
}

export function getDaysRemaining(expirationDate) {
  if (!expirationDate) return null;
  const now = new Date();
  const expiry = new Date(expirationDate);
  const diffTime = expiry - now;
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  return diffDays;
}

export const PIPELINE_STATUTS = [
  { value: 'disponible', label: 'Disponible' },
  { value: 'reserve', label: 'Réservé' },
  { value: 'en_cours', label: 'En cours' },
  { value: 'relance', label: 'Relance' },
  { value: 'rdv', label: 'RDV' },
  { value: 'etude', label: 'Étude' },
  { value: 'devis', label: 'Devis' },
  { value: 'gagne', label: 'Gagné' },
  { value: 'perdu', label: 'Perdu' },
];

export const TYPE_CHAUFFAGE = [
  { value: 'collectif', label: 'Collectif' },
  { value: 'individuel', label: 'Individuel' },
  { value: 'inconnu', label: 'Inconnu' },
];

export const CLASSES_DPE = ['A', 'B', 'C', 'D', 'E', 'F', 'G'];

export const ACTION_TYPES = [
  { value: 'appel', label: 'Appel' },
  { value: 'email', label: 'Email' },
  { value: 'linkedin', label: 'LinkedIn' },
  { value: 'rdv', label: 'Rendez-vous' },
];

export function formatNumber(num) {
  if (num === null || num === undefined) return '-';
  return new Intl.NumberFormat('fr-FR').format(num);
}
